import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={163}
    height={123}
    viewBox="0 0 163 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_32_229)">
      <path
        d="M2.99999 1.46492C-4.00001 -1.53508 -2.50001 10.9649 -2.50001 10.9649V122.965H159.5C159.5 122.965 157.5 105.965 151.5 96.4648C145.5 86.9648 148 101.965 137 99.4648C126 96.9648 129.5 64.4648 124.5 62.4648C119.5 60.4649 121 67.9648 115 66.9648C109 65.9649 108.5 47.4648 101 43.4649C93.5 39.465 97 64.4648 79.5 64.4648C62 64.4649 67.5 39.9648 61 37.4648C54.5 34.9649 61 51.4649 47 51.4649C33 51.4649 30.5 15.5236 24 12.4648C17.5 9.40609 21 25.4648 13 23.4649C4.99998 21.465 9.99999 4.46492 2.99999 1.46492Z"
        fill="url(#paint0_linear_32_229)"
      />
      <path
        d="M9 26.9648C-0.5 25.9648 -2.6 33.3648 -3 34.9648V122.965H159C159 122.965 141 116.465 131.5 109.965C122 103.465 116 89.4648 108.5 84.4648C101 79.4648 97 87.4648 91 84.4648C85 81.4648 77 71.4648 69 66.9648C61 62.4649 49.5 66.9648 40.5 61.9648C31.5 56.9648 18.5 27.9648 9 26.9648Z"
        fill="url(#paint1_linear_32_229)"
      />
      <path
        d="M7.5 42.9649C1 40.9649 -2.5 42.9649 -2.5 42.9649V122.965H102.5C102.5 122.965 81 79.9648 69.5 73.4649C58 66.965 46.5 74.4648 35.5 68.4648C24.5 62.4649 14 44.9649 7.5 42.9649Z"
        fill="url(#paint2_linear_32_229)"
      />
      <path
        d="M8.5 69.9648C2.5 66.9648 -2 58.9648 -2 58.9648L-3 123.965H103.5C103.5 123.965 35.5 74.4648 29.5 71.9648C23.5 69.4648 14.5 72.9648 8.5 69.9648Z"
        fill="url(#paint3_linear_32_229)"
      />
      <path
        d="M-2 58.9648C-2 58.9648 2.5 66.9648 8.5 69.9648C14.5 72.9648 23.5 69.4648 29.5 71.9648C35.5 74.4648 103.5 123.965 103.5 123.965"
        stroke="url(#paint4_linear_32_229)"
      />
      <path
        d="M11 79.9648C5.5 77.9648 -2.5 77.9648 -2.5 77.9648V122.965H159.5C159.5 122.965 130 100.465 125 97.9648C120 95.4648 112.5 97.4648 105.5 95.4648C98.5 93.4648 90.5 84.9648 79 79.9648C67.5 74.9648 35 86.4648 27.5 84.9648C20 83.4648 16.5 81.9648 11 79.9648Z"
        fill="url(#paint5_linear_32_229)"
      />
      <path
        d="M27.5 99.5C5 98.3158 -2.5 85.9648 -2.5 85.9648V123.965H160C160 123.965 142 111.465 133.5 108.965C125 106.465 121.5 113 109 111.5C96.5 110 88.5 87.5 72.5 85.9648C56.5 84.4297 50 100.684 27.5 99.5Z"
        fill="url(#paint6_linear_32_229)"
      />
      <path
        d="M-2.5 85.9648C-2.5 85.9648 5 98.3158 27.5 99.5C50 100.684 56.5 84.4296 72.5 85.9648C88.5 87.5 96.5 110 109 111.5C121.5 113 125 106.465 133.5 108.965C142 111.465 160 123.965 160 123.965"
        stroke="url(#paint7_linear_32_229)"
      />
      <path
        d="M29 106.965C17.5 105.965 -2 99.4648 -2 99.4648V123.465H135C135 123.465 125 118.965 118.5 117.965C112 116.965 98.5 114.965 90.5 111.465C82.5 107.965 77.9296 102.558 66 101.465C53.1812 100.29 40.5 107.965 29 106.965Z"
        fill="url(#paint8_linear_32_229)"
      />
      <path
        d="M-2 99.4648C-2 99.4648 17.5 105.965 29 106.965C40.5 107.965 53.1812 100.29 66 101.465C77.9296 102.558 82.5 107.965 90.5 111.465C98.5 114.965 112 116.965 118.5 117.965C125 118.965 135 123.465 135 123.465"
        stroke="url(#paint9_linear_32_229)"
      />
      <circle cx={57.5} cy={38.5} r={20.5} fill="url(#paint10_radial_32_229)" />
      <circle cx={46} cy={38} r={1} fill="#0C102B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6046 36.72C55.7397 36.4792 56.0445 36.3935 56.2853 36.5287C58.2118 37.6099 60.65 36.9247 61.7312 34.9983C61.8664 34.7575 62.1712 34.6718 62.412 34.807C62.6528 34.9421 62.7384 35.2469 62.6033 35.4877C61.2517 37.8958 58.2039 38.7523 55.7959 37.4007C55.5551 37.2656 55.4694 36.9608 55.6046 36.72Z"
        fill="black"
      />
      <circle cx={68} cy={31} r={1} fill="#0C102B" />
      <circle cx={142} cy={80} r={3} fill="#95E8F3" />
      <circle cx={43} cy={10} r={2} fill="#81BDD2" />
      <circle cx={82.5} cy={44.9648} r={1.5} fill="#744FC5" />
      <circle cx={71} cy={14.4648} r={2} fill="#D88DDC" />
      <circle cx={118} cy={53} r={1} fill="#EB779F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.043 14C97.8343 14 96.0435 15.7909 96.0435 18V22.0239L88 25.5L96.0435 28.9761V32C96.0435 34.2091 97.8343 36 100.043 36H135C137.209 36 139 34.2091 139 32V18C139 15.7909 137.209 14 135 14H100.043Z"
        fill="#57A7BA"
      />
      <path
        d="M106.876 29L105.82 21.3H106.953L107.591 26.899L108.537 21.3H109.681L110.627 26.899L111.265 21.3H112.398L111.342 29H109.989L109.109 23.555L108.229 29H106.876ZM115.77 29.132C115.242 29.132 114.777 29.0147 114.373 28.78C113.97 28.538 113.655 28.2043 113.427 27.779C113.2 27.3537 113.086 26.8587 113.086 26.294C113.086 25.722 113.196 25.2197 113.416 24.787C113.644 24.3543 113.959 24.017 114.362 23.775C114.773 23.533 115.246 23.412 115.781 23.412C116.309 23.412 116.764 23.533 117.145 23.775C117.527 24.0097 117.82 24.325 118.025 24.721C118.238 25.117 118.344 25.5533 118.344 26.03C118.344 26.1033 118.344 26.184 118.344 26.272C118.344 26.3527 118.341 26.4443 118.333 26.547H114.23C114.267 27.053 114.432 27.438 114.725 27.702C115.019 27.9587 115.363 28.087 115.759 28.087C116.104 28.087 116.375 28.0173 116.573 27.878C116.779 27.7313 116.929 27.5333 117.024 27.284H118.201C118.069 27.8047 117.794 28.2447 117.376 28.604C116.958 28.956 116.423 29.132 115.77 29.132ZM115.77 24.424C115.411 24.424 115.092 24.534 114.813 24.754C114.535 24.9667 114.355 25.2673 114.274 25.656H117.178C117.149 25.2893 117.006 24.9923 116.749 24.765C116.493 24.5377 116.166 24.424 115.77 24.424ZM122.366 29.132C121.838 29.132 121.372 29.0147 120.969 28.78C120.566 28.538 120.25 28.2043 120.023 27.779C119.796 27.3537 119.682 26.8587 119.682 26.294C119.682 25.722 119.792 25.2197 120.012 24.787C120.239 24.3543 120.555 24.017 120.958 23.775C121.369 23.533 121.842 23.412 122.377 23.412C122.905 23.412 123.36 23.533 123.741 23.775C124.122 24.0097 124.416 24.325 124.621 24.721C124.834 25.117 124.94 25.5533 124.94 26.03C124.94 26.1033 124.94 26.184 124.94 26.272C124.94 26.3527 124.936 26.4443 124.929 26.547H120.826C120.863 27.053 121.028 27.438 121.321 27.702C121.614 27.9587 121.959 28.087 122.355 28.087C122.7 28.087 122.971 28.0173 123.169 27.878C123.374 27.7313 123.525 27.5333 123.62 27.284H124.797C124.665 27.8047 124.39 28.2447 123.972 28.604C123.554 28.956 123.019 29.132 122.366 29.132ZM122.366 24.424C122.007 24.424 121.688 24.534 121.409 24.754C121.13 24.9667 120.951 25.2673 120.87 25.656H123.774C123.745 25.2893 123.602 24.9923 123.345 24.765C123.088 24.5377 122.762 24.424 122.366 24.424ZM128.346 26.195L128.17 21.3H129.622L129.435 26.195H128.346ZM128.907 29.066C128.635 29.066 128.404 28.978 128.214 28.802C128.023 28.6187 127.928 28.3987 127.928 28.142C127.928 27.8853 128.023 27.669 128.214 27.493C128.404 27.317 128.635 27.229 128.907 27.229C129.185 27.229 129.416 27.317 129.6 27.493C129.79 27.669 129.886 27.8853 129.886 28.142C129.886 28.3987 129.79 28.6187 129.6 28.802C129.416 28.978 129.185 29.066 128.907 29.066Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_32_229"
        x1={103.5}
        y1={37.9648}
        x2={78.4325}
        y2={122.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E978AE" />
        <stop offset={0.26} stopColor="#BE78E9" />
        <stop offset={1} stopColor="#201C92" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_32_229"
        x1={90}
        y1={32}
        x2={78}
        y2={122.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7051FB" stopOpacity={0.38} />
        <stop offset={1} stopColor="#240A9B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_32_229"
        x1={50}
        y1={42.076}
        x2={50}
        y2={122.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#573ADC" stopOpacity={0.34} />
        <stop offset={1} stopColor="#091BB6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_32_229"
        x1={50.25}
        y1={58.9648}
        x2={50.25}
        y2={123.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3E72FF" stopOpacity={0.24} />
        <stop offset={1} stopColor="#112458" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_32_229"
        x1={1.5}
        y1={72.5}
        x2={66.5}
        y2={98.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4B54D3" />
        <stop offset={1} stopColor="#BFC3FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_32_229"
        x1={14}
        y1={82}
        x2={155.5}
        y2={123}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4470D6" />
        <stop offset={0.55} stopColor="#4A89B2" />
        <stop offset={1} stopColor="#002882" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_32_229"
        x1={78.75}
        y1={85.4248}
        x2={78.75}
        y2={123.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#294991" />
        <stop offset={1} stopColor="#0C2764" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_32_229"
        x1={29.5}
        y1={94}
        x2={126.5}
        y2={114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5D77FF" />
        <stop offset={0.57} stopColor="#5DECFF" />
        <stop offset={1} stopColor="#122E6D" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_32_229"
        x1={66.5}
        y1={99.4648}
        x2={66.5}
        y2={123.465}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#172B60" />
        <stop offset={1} stopColor="#051849" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_32_229"
        x1={26}
        y1={107.5}
        x2={113.5}
        y2={120.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15298E" />
        <stop offset={0.565} stopColor="#366BE0" />
        <stop offset={1} stopColor="#00226D" />
      </linearGradient>
      <radialGradient
        id="paint10_radial_32_229"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57 30.5) rotate(88.9949) scale(28.5044)"
      >
        <stop stopColor="#F4C386" />
        <stop offset={0.53} stopColor="#F0989F" />
        <stop offset={1} stopColor="#D22B6F" />
      </radialGradient>
      <clipPath id="clip0_32_229">
        <path
          d="M0 0H163V122.965H12C5.37258 122.965 0 117.592 0 110.965V0Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
